import { Address } from '../types/address/address'

export const findDeliveryAddress = (addresses?: Record<string, Address>): Address | undefined => {
  if (addresses) {
    return Object.values(addresses).find(
      (address) => address.defaultForDelivery && address.validAddressForDelivery,
    )
  }
  return undefined
}
